/* eslint-disable @nx/enforce-module-boundaries */
import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useESkatVisibility } from '../../../../ESkat';
import type { BankFormGroupData } from '../../../FormData.dk.types';
import { radioOptions, yearsAsBankCustomer } from '../../../config/globals';
import { requiredField } from '../../shared-config';
import {
  accountNumberFieldOptions,
  registrationNumberFieldOptions,
} from './config';

export function BankFormGroup() {
  const { t } = useTranslation();

  const filledByESkat = useESkatVisibility('HasUnemploymentFund');

  return (
    <>
      <RadioFieldUI<BankFormGroupData>
        name="LoanApplication/YearsAsBankCustomer"
        label={t('YearsAsBankCustomer.label')}
        data-testid="year-as-bank-customer-radio"
        radioStyle="both"
        options={yearsAsBankCustomer}
        registerOptions={requiredField}
      />

      <RadioFieldUI<BankFormGroupData>
        name="LoanApplication/HasDankort"
        label={t('HasDankort.label')}
        data-testid="has-dankort-radio"
        radioStyle="both"
        options={radioOptions}
        registerOptions={requiredField}
      />

      <RadioFieldUI<BankFormGroupData>
        name="LoanApplication/HasOtherPaymentCards"
        label={t('HasOtherPaymentCards.label')}
        data-testid="has-other-cards-radio"
        radioStyle="both"
        options={radioOptions}
        registerOptions={requiredField}
      />

      <Grid columns={{ s: 1, m: 1, l: 2 }}>
        <NumberFieldUI<BankFormGroupData>
          name="LoanApplication/RegistrationNumber"
          label={t('RegistrationNumber.label')}
          data-testid="registration-number-input"
          {...registrationNumberFieldOptions}
        />

        <NumberFieldUI<BankFormGroupData>
          name="LoanApplication/AccountNumber"
          label={t('AccountNumber.label')}
          data-testid="account-number-input"
          {...accountNumberFieldOptions}
        />
      </Grid>

      {!filledByESkat && (
        <RadioFieldUI<BankFormGroupData>
          name="LoanApplication/HasUnemploymentFund"
          label={t('HasUnemploymentFund.label')}
          data-testid="has-unemployment-fund-radio"
          radioStyle="both"
          options={radioOptions}
          registerOptions={requiredField}
        />
      )}
    </>
  );
}
